import {
  validateExclusion,
  validateNumber,
} from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

function validateMin(key, newValue, oldValue, changes, content) {
  const min =
    newValue ?? changes.minimumLengthOfStay ?? content.minimumLengthOfStay;
  const max = changes.maximumLengthOfStay ?? content.maximumLengthOfStay;

  if (min !== null && max !== null && min > max) {
    return false;
  }

  return true;
}

function validateMax(key, newValue, oldValue, changes, content) {
  const max =
    newValue ?? changes.maximumLengthOfStay ?? content.maximumLengthOfStay;
  const min = changes.minimumLengthOfStay ?? content.minimumLengthOfStay;

  if (min !== null && max !== null && min > max) {
    return false;
  }

  return true;
}

function validateGapNightsRequired(key, newValue, oldValue, changes, content) {
  const enabled = changes.gapNightsEnabled ?? content.gapNightsEnabled;

  if (
    enabled &&
    (newValue === null || newValue === undefined || newValue === '')
  ) {
    return false;
  }

  return true;
}

function validateGapNightsLookaheadStart(
  key,
  newValue,
  oldValue,
  changes,
  content,
) {
  const start =
    newValue ??
    changes.gapNightsDaysBeforeCheckInStart ??
    content.gapNightsDaysBeforeCheckInStart;
  const end =
    changes.gapNightsDaysBeforeCheckInEnd ??
    content.gapNightsDaysBeforeCheckInEnd;

  if (start !== null && end !== null && Number(start) <= Number(end)) {
    return false;
  }

  return true;
}

function validateGapNightsLookaheadEnd(
  key,
  newValue,
  oldValue,
  changes,
  content,
) {
  const end =
    newValue ??
    changes.gapNightsDaysBeforeCheckInEnd ??
    content.gapNightsDaysBeforeCheckInEnd;
  const start =
    changes.gapNightsDaysBeforeCheckInStart ??
    content.gapNightsDaysBeforeCheckInStart;

  if (start !== null && end !== null && Number(start) <= Number(end)) {
    return false;
  }

  return true;
}

export const BookingRestrictionValidation = {
  minimumLengthOfStay: [
    validateNumber({
      gte: 0,
      integer: true,
      allowBlank: true,
    }),
    customMessageValidator(
      'booking_minimum_length_of_stay_too_high',
      validateMin,
    ),
  ],
  airbnbMinimumAdvanceNotice: [
    validateNumber({ gte: 0, lte: 168, integer: true, allowBlank: true }),
    validateExclusion({ range: [25, 47] }),
    validateExclusion({ range: [49, 71] }),
    validateExclusion({ range: [73, 167] }),
  ],
  homeawayMinimumAdvanceNotice: validateNumber({
    gte: 0,
    lte: 999,
    integer: true,
    allowBlank: true,
  }),
  airbnbMaximumLengthOfStay: validateNumber({
    gte: 0,
    lte: 1125,
    integer: true,
    allowBlank: true,
  }),
  maximumLengthOfStay: [
    validateNumber({
      gte: 0,
      lte: 1125,
      integer: true,
      allowBlank: true,
    }),
    customMessageValidator(
      'booking_maximum_length_of_stay_exceeded',
      validateMax,
    ),
  ],
  minimumAdvanceNotice: [
    validateNumber({
      gte: 0,
      integer: true,
      allowBlank: true,
    }),
  ],
  preparationDays: validateNumber({ gte: 0, lte: 2, allowBlank: true }),
  multiUnitCount: validateNumber({
    gte: 0,
    lte: 500,
    integer: true,
    allowBlank: true,
  }),
  gapNightsMinimumLengthOfStay: [
    validateNumber({
      gte: 1,
      integer: true,
      allowBlank: true,
    }),
    customMessageValidator(
      'gap_nights_field_required',
      validateGapNightsRequired,
    ),
  ],
  gapNightsDaysBeforeCheckInStart: [
    validateNumber({
      gte: 0,
      integer: true,
      allowBlank: true,
    }),
    customMessageValidator(
      'gap_nights_field_required',
      validateGapNightsRequired,
    ),
    customMessageValidator(
      'gap_nights_lookahead_start_must_be_greater',
      validateGapNightsLookaheadStart,
    ),
  ],
  gapNightsDaysBeforeCheckInEnd: [
    validateNumber({
      gte: 0,
      integer: true,
      allowBlank: true,
    }),
    customMessageValidator(
      'gap_nights_field_required',
      validateGapNightsRequired,
    ),
    customMessageValidator(
      'gap_nights_lookahead_end_must_be_smaller',
      validateGapNightsLookaheadEnd,
    ),
  ],
};
